import * as React from 'react';
import Card from 'antd/lib/card';
import { ICardHistoryItem, ICardData, getScheme } from '../Models/Report';
import List from 'antd/lib/list';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import './History.scss';
import Search from 'antd/lib/input/Search';
import EventUtils from '../Utils/EventUtils';
import { EReport } from '../Actions/Report/Actions';
import { ReactElement } from 'react';
import { ReactComponent as Train } from '../Assets/images/train.svg';
import { ReactComponent as Vehicle } from '../Assets/images/vehicle.svg';
import IconSearch from './IconSearch';

export interface IHistoryProps {
	data: ICardData[];
	report: string;
	reportType: EReport;
	icon?: ReactElement;
}

export interface ICardHistoryItemProps {
	data: ICardHistoryItem;
	icon?: any;
}

export const CardHistoryItem = (props: ICardHistoryItemProps) => (
	<Col span={12} className='History-Item'>
		<div className='History-Item-Title'>{props.data.descriptor.label}</div>
		<div className='History-Item-Value'>
			{props.data.descriptor.transform
				? props.data.descriptor.transform(
						props.data.data[props.data.descriptor.field]
				  )
				: props.data.data[props.data.descriptor.field]}
		</div>
	</Col>
);

export const CardHistoryItemTitle = (props: ICardHistoryItemProps) => (
	<div className='History-Item Header'>
		{props.icon && props.icon(props.data.data)}
		<div className='History-Item-Title'>{props.data.descriptor.label}</div>
		<div className='History-Item-Value'>
			{props.data.data[props.data.descriptor.field]}
		</div>
	</div>
);

export const CardHistory = (props: ICardData) => (
	<Card
		title={
			<div>
				<CardHistoryItemTitle icon={props.icon} data={props.title} />
			</div>
		}>
		<Row gutter={14}>
			{props.content.map(d => (
				<CardHistoryItem key={`card-history-item-${d.descriptor.field}`} data={d} />
			))}
		</Row>
	</Card>
);

const History = (props: IHistoryProps) => {
	const scheme = getScheme(props.reportType)
	const [search, setSearch] = React.useState('');
	const keys = Object.keys(scheme.fields);
	keys.push(scheme.title)
	const onSearch = (d: any) => {
		if (!d.title) {
			return false;
		}

		for (let i = 0; i < keys.length; i += 1) {
			const field = keys[i];
			const value: string = d.title.data[field];
			const trans = scheme.transforms[field];
			if (value && (value.toString().toLowerCase().indexOf(search.toLowerCase()) >= 0 ||  (trans && trans(value).toString().toLowerCase().indexOf(search.toLowerCase()) >= 0))) {
				return true;
			}
		}
		return false;
	}
	let icon: any = undefined;
	if (scheme.icon) {
		icon = (props: any) => {
			const type = props.tipo_Transporte || '';
			if (!props.tipo_Transporte) {
				return <span />;
			}
			return <div className="icon">
				{type.trim().toLowerCase() === 'tren' ? <Train /> : <Vehicle /> }
			</div>
		}
	}
	return (
		<div className='History'>
			<h1>Historial {props.report} en Puerto Año en Curso</h1>
			<p>Estatus de cobre en Puerto Angamos</p>
			<div className='History-Search'>
				<div className="History-Search-Button">
					<IconSearch />
				</div>
				<div className="History-Search-Input">
					<Search
						onChange={(evt) => {
							const value = evt.target.value;
							EventUtils.debounce(() => setSearch(value), 500) }
						}
						placeholder={`Explorar por ${scheme.titleLabel}`} />
					</div>
			</div>
			<List
				pagination={{
					pageSize: 4,
					size: 'small',
				}}
				grid={{ gutter: 20, column: 2 }}
				dataSource={(search.trim().length > 0 ? props.data.filter(onSearch) : props.data)}
				renderItem={(item, index) => (
					<List.Item>
						<CardHistory key={`card-history-${index}`} icon={icon} {...item} />
					</List.Item>
				)}
			/>
		</div>
	);
};

export default History;
